<app-form-field-wrapper
  [label]="label"
  [name]="name"
  [colSize]="colSize"
  [formField]="formField">
  <p-dropdown
    class="icon-dropdown"
    [options]="options"
    optionLabel="label"
    [ngModel]="icon"
    (ngModelChange)="onChange($event)"
    optionValue="key">
    <ng-template let-item pTemplate="selectedItem">
      @if (mode === 'maki') {
        <app-svg-icon [path]="item.path"></app-svg-icon>
      } @else {
        <i [class]="item.key"></i>
      }
    </ng-template>
    <ng-template let-icon pTemplate="item">
      <div class="flex icon-row" [ngClass]="{ 'mode-fa': mode === 'fa' }">
        @if (mode === 'maki') {
          <app-svg-icon [path]="icon.path"></app-svg-icon>
        } @else {
          <i [class]="'fas fa-' + icon.key"></i>
        }
      </div>
    </ng-template>
  </p-dropdown>
</app-form-field-wrapper>
